import { useMutation } from 'react-query';
import axios from 'axios';

export const useUploadS3File = (onProgressChange) =>
  useMutation(
    ['uploadS3File'],
    async ({ signedUrl, file }) => axios.put(signedUrl, file, {
      headers: {
        'Content-Type': 'video/mp4',
      },
      onUploadProgress: progressEvent => {
        const progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
        onProgressChange(progress);
      },
    }),
    {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  );
